import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=1395fa76&scoped=true&"
import script from "./js/article-item.js?vue&type=script&lang=js&"
export * from "./js/article-item.js?vue&type=script&lang=js&"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&id=1395fa76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395fa76",
  null
  
)

export default component.exports